import WorkspaceMenu from './WorkspaceMenu';

export default WorkspaceMenu;
